import { useMemo, useState } from 'react';
import { useWatch } from 'react-hook-form';
import { useStreetSuggestions } from '@/apiHooks/geoAutocomplete.hook';
import { useIntl } from '@/i18n';
import { AddressAutocomplete } from './AddressAutocomplete';

export const StreetAutocomplete = ({ className }: { className: string }) => {
  const { t } = useIntl();
  const [postalCode, city] = useWatch({ name: ['postalCode', 'city'] });
  const [streetQuery, setStreetQuery] = useState('');
  const { data, isFetching, isError } = useStreetSuggestions(postalCode, city, streetQuery);
  const suggestions = useMemo(
    () =>
      data?.map((suggestion) => ({
        ...suggestion,
        label: suggestion.value,
        matches: suggestion.label.startsWith(suggestion.value) ? suggestion.matches : [],
      })),
    [data],
  );
  return (
    <AddressAutocomplete
      name='street'
      label={t({ id: 'benefits.adac.form.street' })}
      className={className}
      disabled={!/^\d{5}$/.test(postalCode) || !city.trim()}
      suggestions={suggestions}
      loading={isFetching}
      lookupFailed={isError}
      onSearch={setStreetQuery}
    />
  );
};
